<p-dialog
  (onHide)="onContactModalHide()"
  [visible]="showContactMeDialog"
  (visibleChange)="onFlag('showContactMeDialog', $event)"
  [blockScroll]="false"
  [draggable]="false"
  [modal]="true"
  [style]="{
    width: '100%',
    maxWidth: '500px',
    overflow: isMobile ? 'hidden' : 'initial'
  }"
  class="contact-me-dialog"
  [appendTo]="isSearch ? 'body' : null"
  styleClass="pitch-modal">
  <app-contact-modal
    (hideModal)="onContactModalHide()"
    (submitForm)="onContactModalSubmit($event)"
    *ngIf="showContactMeDialog"></app-contact-modal>
</p-dialog>

<p-dialog
  [visible]="showDoneDialog"
  (visibleChange)="onFlag('showDoneDialog', $event)"
  [blockScroll]="false"
  [draggable]="false"
  [modal]="true"
  [style]="{ width: '100%', maxWidth: '300px' }"
  class="contact-me-dialog"
  styleClass="pitch-modal"
  appendTo="body">
  <app-done-modal (done)="onClickDoneDialog()">
    <ng-template #content>
      <p>Got it, we’ll be in touch soon!</p>
    </ng-template>
  </app-done-modal>
</p-dialog>
<p-dialog
  *ngIf="showContactInfoDialog"
  [visible]="showContactInfoDialog"
  (visibleChange)="onFlag('showContactInfoDialog', $event)"
  [blockScroll]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [modal]="true"
  [ngClass]="{ 'contact-me-dialog-mob': isMobile }"
  [style]="{ background: isMobile ? 'transparent' : 'white' }"
  class="contact-info-dialog"
  appendTo="body">
  <div [ngClass]="{ 'contact-info': !isMobile, 'contact-info-mob': isMobile }">
    <div [ngClass]="{ 'color-white': isMobile }" class="text-center">
      <p
        [ngClass]="{
          'white-space-nowrap': userName?.length <= 23 && !isMobile
        }"
        class="text-2xl p-0 mt-2 mb-0">
        Thanks! {{ userName }} should be
      </p>
      <p class="text-2xl p-0 mt-0 mb-2">getting in touch with you.</p>
    </div>

    <div
      [ngClass]="{ 'col-3': !isMobile, 'col-4': isMobile }"
      class="mx-auto min-w-max">
      <img
        [src]="
          'assets/images/pitch-card-svg/' +
          (isMobile ? 'contact-me-white.svg' : 'contact-me.svg')
        "
        alt="contact-me"
        class="full-width" />
    </div>
  </div>
</p-dialog>
<p-dialog
  (onHide)="closeContactSwapDialog()"
  *ngIf="showContactSwapDialog"
  [visible]="showContactSwapDialog"
  (visibleChange)="onFlag('showContactSwapDialog', $event)"
  [blockScroll]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [showHeader]="false"
  [modal]="false"
  [baseZIndex]="4000"
  maskStyleClass="contact-swap-dialog-mask"
  [position]="
    isMobile && isPortraitMode
      ? 'bottom'
      : isMobile && !isPortraitMode
        ? 'top'
        : 'center'
  "
  [style]="{
    'border-radius': '8px 8px 0 0',
    margin: 0,
    minWidth: '370px',
    maxWidth: '500px',
    width: '100%',
    padding: '24px',
    height: !isEmbedded && isMobile && !isPortraitMode ? '100vh' : 'unset'
  }"
  [ngClass]="{ 'dialog-p-0 dialog-m-0 dialog-bottom': isMobile }"
  class="dialog p-0 contact-swap-dialog"
  appendTo="body">
  <div class="flex justify-content-end">
    <a
      class="color-black contact-swap-btn-skip"
      (click)="closeContactSwapDialog()"
      >Skip</a
    >
  </div>
  <h3 class="contact-swap-title m-0 mb-1">Contact Swap</h3>
  <span class="contact-swap-subtitle"
    >Share your contact information with {{ currentPitchCard.name }}</span
  >
  <form
    [formGroup]="contactSwapForm"
    (ngSubmit)="onContactSwapSubmit()"
    class="contact-swap-form mt-3">
    <span class="p-float-label">
      <input
        id="swap-name"
        formControlName="name"
        placeholder="Name"
        class="input-contactswap sm"
        pInputText />
    </span>
    <span class="p-float-label">
      <input
        id="swap-business-name"
        formControlName="businessName"
        placeholder="Business Name"
        class="input-contactswap sm"
        pInputText />
    </span>
    <span class="p-float-label">
      <app-country-input
        formControlName="phone"
        [containerStyleClass]="'bordered-container'"
        [inputStyleClass]="'borderless'"
        [flagDropdownStyle]="'borderless'"
        [isNewControlResponse]="true"
        [floatLabel]="false"
        [placeholder]="'Phone'"
        [required]="true"></app-country-input>
    </span>
    <span class="p-float-label">
      <input
        id="swap-email"
        formControlName="email"
        placeholder="Email"
        class="input-contactswap sm"
        pInputText />
    </span>
    <span class="p-float-label">
      <input
        id="swap-notes"
        formControlName="notes"
        placeholder="Notes (eg - Where did we meet?)"
        class="input-contactswap sm"
        pInputText />
      <!-- <label for="swap-notes">Notes (eg - Where did we meet?)</label> -->
    </span>
    <button
      type="submit"
      class="button-simple basic m-auto mt-2 mb-1"
      [disabled]="!contactSwapForm.valid">
      Send
    </button>
    <span class="text-center">Your data will always be kept private.</span>
  </form>
</p-dialog>

<p-dialog
  [visible]="showSentDialog"
  (visibleChange)="onFlag('showSentDialog', $event)"
  [modal]="true"
  [draggable]="false"
  [dismissableMask]="true"
  [blockScroll]="true"
  [showHeader]="false"
  (onHide)="closeContactSwapDialog(); onFlag('showSentDialog', false)"
  [style]="{ minWidth: '300px', maxWidth: '350px' }"
  styleClass="sent-dialog"
  [appendTo]="isSearch ? 'body' : null">
  <div class="p-2 sent-content flex flex-column justify-content-center">
    <div class="flex justify-content-end">
      <div class="flex justify-content-end">
        <a
          class="color-black contact-swap-btn-skip"
          (click)="closeContactSwapDialog()"
          >Done</a
        >
      </div>
    </div>
    <h3 class="sent-title text-center">Sent!</h3>
    <p
      class="text-center"
      *ngIf="
        currentPitchCard?.links?.length ||
        currentPitchCard?.websiteLink ||
        currentPitchCard?.calendarLink
      ">
      You can also connect with me here.
    </p>
    <div
      class="flex flex-column align-items-center overflow-scroll pl-2 pr-2"
      *ngIf="
        currentPitchCard?.links?.length ||
        currentPitchCard?.websiteLink ||
        currentPitchCard?.calendarLink
      ">
      <div class="link-element flex gap-2">
        <a
          class="website-link-element h-6rem w-6rem flex flex-column justify-content-between align-items-center border-round-xl no-underline py-3"
          [href]="
            currentPitchCard.websiteLink.includes('http')
              ? currentPitchCard.websiteLink
              : 'https://' + currentPitchCard.websiteLink
          "
          target="_blank"
          *ngIf="currentPitchCard.websiteLink">
          <img
            class="logo max-w-2rem max-h-2rem"
            src="assets/images/new-pitch-card-icons/website-icon.svg" />
          <span class="text text-center">
            {{ currentPitchCard.websiteLinkCallToAction || 'Visit Website' }}
          </span>
        </a>
        <a
          class="calendar-link-element h-6rem w-6rem flex flex-column justify-content-between align-items-center border-round-xl no-underline py-3"
          [href]="
            currentPitchCard.calendarLink.includes('http')
              ? currentPitchCard.calendarLink
              : 'https://' + currentPitchCard.calendarLink
          "
          target="_blank"
          *ngIf="currentPitchCard.calendarLink">
          <img
            class="logo max-w-2rem max-h-2rem"
            src="assets/images/new-pitch-card-icons/calendar-icon.svg" />
          <span class="text text-center">
            {{ currentPitchCard.calendarLinkCallToAction || 'Calendar' }}
          </span>
        </a>
        <a
          *ngFor="let link of currentPitchCard.links"
          [href]="
            link.link.includes('http') ? link.link : 'https://' + link.link
          "
          target="_blank"
          class="other-link-element h-6rem w-6rem flex flex-column justify-content-between align-items-center border-round-xl no-underline py-3 overflow-hidden">
          <img
            class="logo max-w-2rem max-h-2rem"
            [src]="
              'https://www.google.com/s2/favicons?domain=' +
              link.link +
              '&sz=256'
            " />
          <span
            class="text text-center pl-2 pr-2 overflow-hidden full-width text-ellipsis"
            >{{ link.callToAction || link.link }}</span
          >
        </a>
      </div>
    </div>
  </div>
</p-dialog>
